(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".gs-about-heading-wrapper",
          start: "20% 20%",
          end: "60% center",
          scrub: 1,
        },
      })
      .fromTo(
        ".gs-about-heading-wrapper span",
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, ease: "power2.out" }
      )
      .to(".gs-about-heading-wrapper img", {
        scale: 1,
        duration: 1,
        ease: "power2.out",
      });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-rotation-section"] && !Shopify.designMode) return;
  try {
    
  const { weDos, weDonts } = window.aboutRotationData;
  class RotationGallery {
    constructor(containerSelector, gallerySelector, data, config) {
      this.container = document.querySelector(containerSelector);
      this.gallery = document.querySelector(gallerySelector);
      this.data = data;
      this.config = config;

      if (!this.container || !this.gallery) {
        console.error(`Required elements not found for ${containerSelector}`);
        return;
      }

      this.init();
    }

    init() {
      this.setupConfig();
      this.createItems();
      this.createCenterCircle();
      this.updatePositions(0);
      this.setActiveItem(0);
    }

    setupConfig() {
      const { width, height } = this.container.getBoundingClientRect();
      const numberOfItems = Math.min(30, this.data.length);
      const baseRadius = 1000;
      const scaleFactor = Math.min(window.innerWidth, window.innerHeight);
      const radius = Math.max(400, Math.min(800, baseRadius * scaleFactor));
      const centerX = radius - 1400;
      const centerY = height / 2;
      const angleIncrement = (2 * Math.PI) / numberOfItems;

      this.config = {
        ...this.config,
        numberOfItems,
        width,
        height,
        radius,
        centerX,
        centerY,
        angleIncrement,
      };

      this.rotationState = { offset: 0 };
      this.items = [];
    }

    createItems() {
      this.data.slice(0, this.config.numberOfItems).forEach((itemData, i) => {
        const item = document.createElement('div');
        item.className = this.config.itemClass;
        item.dataset.index = i;

        const p = document.createElement('p');
        p.textContent = itemData.name;
        item.appendChild(p);

        item.addEventListener('click', () => this.rotateToItem(i));

        this.gallery.appendChild(item);
        this.items.push(item);
      });
    }

    createCenterCircle() {
      const centerCircle = document.createElement('div');
      centerCircle.className = this.config.centerCircleClass;
      centerCircle.innerHTML = this.config.centerText;

      Object.assign(centerCircle.style, this.config.centerCircleStyle);
      this.container.appendChild(centerCircle);
    }

    updatePositions(offset) {
      this.items.forEach((item) => {
        const idx = parseInt(item.dataset.index);
        const angle = idx * this.config.angleIncrement + offset;
        const x = this.config.centerX + this.config.radius * Math.cos(angle);
        const y = this.config.centerY + this.config.radius * Math.sin(angle);
        const rot = (angle * 180) / Math.PI;

        gsap.set(item, {
          x: `${x}px`,
          y: `${y}px`,
          rotation: rot,
        });
      });
    }

    setActiveItem(index) {
      document.querySelector(`.${this.config.itemClass}.active`)?.classList.remove('active');
      document.querySelector(`.${this.config.itemClass}[data-index="${index}"]`)?.classList.add('active');
    }

    rotateToItem(targetIndex) {
      const rawTarget = -targetIndex * this.config.angleIncrement;
      const delta = gsap.utils.wrap(-Math.PI, Math.PI, rawTarget - this.rotationState.offset);
      const newOffset = this.rotationState.offset + delta;

      if (delta === 0) return;

      this.setActiveItem(targetIndex);

      gsap.to(this.rotationState, {
        offset: newOffset,
        duration: this.config.duration,
        ease: 'power4.out',
        onUpdate: () => {
          this.updatePositions(this.rotationState.offset);
        },
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    // WE DO Gallery
    new RotationGallery('.about-rotation-container', '.gallery', weDos, {
      itemClass: 'item',
      centerCircleClass: 'center-circle',
      centerText: 'WE DO',
      duration: 0.7,
      centerCircleStyle: {
        position: 'absolute',
        width: `${800 / 2}px`,
        height: `${800 / 2}px`,
        left: '-200px',
        // top:'0px',
        transform: 'translate(0%, 14.5%)',
        background: '#F19304',
        color: '#FFF',
        display: 'flex',
        justifyContent: 'end',
        paddingRight: '10px',
        fontWeight: '900',
        fontSize: '52px',
        fontFamily: 'Merel',
        alignItems: 'center',
        borderRadius: '50%',
        pointerEvents: 'none',
        zIndex: '1',
      },
    });

    // WE DON'T Gallery
    new RotationGallery('.wedonts-rotation-container', '.wedonts-gallery', weDonts, {
      itemClass: 'wedonts-item',
      centerCircleClass: 'wedonts-center-circle',
      centerText: "WE <br>DON'T",
      duration: 1,
      centerCircleStyle: {
        position: 'absolute',
        width: `${800 / 2}px`,
        height: `${800 / 2}px`,
        left: '-200px',
        // top: '57%',
        transform: 'translateY(14.5%)',
        background: '#1D0525',
        color: '#FFF2D8',
        display: 'flex',
        justifyContent: 'end',
        paddingRight: '10px',
        lineHeight: '60px',
        fontWeight: '900',
        fontSize: '52px',
        fontFamily: 'Merel',
        alignItems: 'center',
        borderRadius: '50%',
        pointerEvents: 'none',
        zIndex: '1',
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
